import * as XLSX from "xlsx";
import { Button } from "./ui/button";
import { Download } from "lucide-react";
import { toast } from "react-hot-toast";

interface ExcelDownloadButtonProps {
  getData: () => Promise<any[]>;
  filename?: string;
}

const ExcelDownloadButton = ({ getData, filename = "data" }: ExcelDownloadButtonProps) => {
  const handleDownload = async () => {
    try {
      const data = await getData();
      if (!data || data.length === 0) {
        toast.error("No data to export.");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${filename}.xlsx`);
      toast.success("Excel downloaded!");
    } catch (err) {
      toast.error("Failed to download Excel.");
    }
  };

  return (
    <Button variant="outline" onClick={handleDownload} className="flex items-center gap-2">
      <Download className="w-4 h-4" />
      Download Excel
    </Button>
  );
};

export default ExcelDownloadButton;